import { BreadcrumbItem } from "./BreadcrumbItem/BreadcrumbItem";

import * as styles from "./Breadcrumb.styles";

interface Props {
  breadcrumbLinkItems: { title: string; href: string }[];
}

const Breadcrumb = ({ breadcrumbLinkItems }: Props) => {
  return (
    <ul css={styles.listStyles}>
      {breadcrumbLinkItems.map((breadcrumbLinkItem, index) => (
        <BreadcrumbItem key={index} {...breadcrumbLinkItem} />
      ))}
    </ul>
  );
};

export { Breadcrumb };
